



























import { defineComponent, ref, watch } from "@vue/composition-api";
import { format, parse } from "date-fns/esm";

export default defineComponent({
  name: "EditableInput",
  props: {
    value: { type: String }
  },
  setup(props, context) {
    const isEditing = ref(false);

    const pending = ref(props.value);

    const commit = () => {
      context.emit("input", pending.value);
      isEditing.value = false;
    };

    const cancel = () => {
      isEditing.value = false;
      pending.value = props.value;
    };

    watch(() => props.value, cancel);

    return { isEditing, pending, commit, cancel };
  }
});
